import React from 'react';
import routes from 'routes/routes';
import { Wrapper, Text, FooterLink } from './styled';

const Copyright = (props) => {
	const year = new Date().getFullYear();
	return (
		<Wrapper {...props}>
			<Text>
				© Copyright {year} Flass Technologies. All rights reserved.
			</Text>
			<FooterLink to={routes.PRIVACY}>Privacy Policy</FooterLink>
			<FooterLink to={routes.TERMS}>Terms of Service</FooterLink>
		</Wrapper>
	);
};

export default Copyright;
